import { render, staticRenderFns } from "./MaterialTemplates.vue?vue&type=template&id=1bc66539&"
import script from "./MaterialTemplates.vue?vue&type=script&lang=js&"
export * from "./MaterialTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports